import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import "./style.css";
import "vuetify/dist/vuetify.min.css";
import axios from "axios";
import Cookies from "js-cookie";
import store from "./store";
import { eventBus } from "./eventBus";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
// chart
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("VueApexCharts", VueApexCharts);
//
Vue.prototype.$eventBus = eventBus;
// import VueElementLoading from 'vue-element-loading'
// import ServerError from './common/errorPage'
// import ImageLoader from './common/imageLoader'
// import PageLoader from './common/pageLoader'

// import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

import CustomInput from "@/common/customInput.vue";
Vue.component("CustomInput", CustomInput);
import CustomButton from "@/common/customButton.vue";
Vue.component("CustomButton", CustomButton);
// Vue.component('ServerError', ServerError)
// Vue.component('ImageLoader', ImageLoader)
// Vue.component('PageLoader', PageLoader)
// Vue.component('VueElementLoading', VueElementLoading)
Vue.prototype.$axios = axios;
Vue.prototype.$cookies = Cookies;
window.axios = require("axios");
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";

const token = Cookies.get("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit("logoutUser");
    }
    return Promise.reject(error);
  }
);

Vue.prototype.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  vuetify,
  VueTimepicker,
  Cropper,
  render: (h) => h(App),
}).$mount("#app");
